import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3><span>LC</span> Lucas Chen</h3>
            <p>
              Computer Engineering candidate focused on automation,
              embedded software, and test infrastructure.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Navigate</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('about')}>About Me</button></li>
              <li><button onClick={() => scrollToSection('projects')}>Projects</button></li>
              <li><button onClick={() => scrollToSection('experience')}>Experience</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <ul className="footer-links">
              <li>
                <a 
                  href="https://www.linkedin.com/in/lucas-chen-5005aa382/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="mailto:lachenakis@gmail.com">
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Lucas Chen. All rights reserved.</p>
          <p>Designed and built with React.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
